<script>
import Messages from '../Message'
import { DropdownComponent } from 'vue-elder-dropdown'
import { InputComponent } from 'vue-elder-input'
import ButtonGroup from '@kvass/button-group'
import moment from 'moment'

export default {
  props: {
    item: Object,
    scope: Object,
  },
  data() {
    return {
      copy: null,
    }
  },
  computed: {
    is() {
      return Messages[this.item.event.replace(/\:/g, '-')] || Messages.default
    },
    icon() {
      if (this.item.event === 'note') return 'fa-pro-light:note-sticky'
      if (this.item.event === 'form:submit') return 'fa-pro-light:square-list'
      if (this.item.event.startsWith('milestone:purchase:')) return 'fa-pro-light:party-horn'
      if (this.item.event.startsWith('milestone:unpurchase:')) return 'fa-pro-light:thumbs-down'
      if (this.item.event.startsWith('milestone:')) return 'fa-pro-light:flag-pennant'
      if (this.item.event.endsWith(':pageview')) return 'fa-pro-light:eye'
      if (this.item.event.endsWith(':filter')) return 'fa-pro-light:eye'
      if (this.item.event.endsWith(':favorite:residential')) return 'fa-pro-light:heart'
      if (this.item.event.endsWith(':floorplan:residential')) return 'fa-pro-light:ruler-combined'

      return 'fa-pro-light:globe'

      switch (this.item.data.screen_size) {
        case 'Mobile':
          return 'fa-pro-light:mobile'
        default:
          return 'fa-pro-light:browser'
      }
    },
    date() {
      const date = moment(this.copy ? this.copy.date : this.item.date)

      return {
        readable: date.calendar({ lastWeek: 'LLL', sameElse: 'LLL' }),
        input: date.format('YYYY-MM-DDTHH:mm'),
      }
    },
    hasAction() {
      return ['note'].includes(this.item.event)
    },
  },
  methods: {
    edit() {
      this.copy = structuredClone(this.item)
      this.$emit('edit')
      this.$nextTick(() => this.$el.scrollIntoView({ behavior: 'smooth', block: 'nearest' }))
    },
    submit() {
      const { message, date } = this.copy
      this.item.message = message
      this.item.date = date

      this.copy = null

      this.$emit('submit', this.item)
    },
    remove(close) {
      this.$emit('remove', this.item)
      close()
    },
    setDate(value) {
      this.copy.date = moment(value).toDate()
    },
    moment(date) {
      return moment(date)
    },
  },
  components: {
    ...Messages,
    DropdownComponent,
    ButtonGroup,
    InputComponent,
  },
}
</script>

<template>
  <div :class="['lead-activities__list-item', { 'lead-activities__list-item--edit': copy }]">
    <div v-if="!copy" data-part="author">{{ item.author.name }}</div>
    <div class="lead-activities__icon" :data-event="item.event">
      <Icon :icon="icon" />
    </div>
    <div data-part="time">
      <template v-if="!copy">{{ date.readable }}</template>
      <InputComponent
        v-else
        :value="date.input"
        :max="moment().format('YYYY-MM-DDTHH:mm')"
        @input="$ev => setDate($ev)"
        type="datetime-local"
      />
    </div>

    <component
      v-if="!copy"
      :is="is"
      :value="item"
      :class="[`lead-activities__message`]"
      :scope="scope"
      :data-event="item.event"
      data-part="message"
    />
    <textarea v-else v-model="copy.message" autofocus :placeholder="$t('typeHere') + '...'" ref="input"></textarea>

    <div v-if="hasAction" data-part="action">
      <DropdownComponent v-if="!copy" :close-on-click="false">
        <ButtonComponent icon="fa-pro-light:angle-down" />
        <template #dropdown="{ close }">
          <ButtonComponent :label="$t('edit')" icon="fa-pro-light:pen" @click="edit" />
          <ButtonComponent :label="$t('remove')" icon="fa-pro-light:trash" @click="() => remove(close)" confirm />
        </template>
      </DropdownComponent>
      <ButtonGroup v-else>
        <ButtonComponent icon="fa-pro-light:check" @click="submit" />
        <ButtonComponent icon="fa-pro-light:times" @click="copy = null" />
      </ButtonGroup>
    </div>
  </div>
</template>
